import React from 'react';
import { Link } from 'react-router-dom';
import './FighterModal.css';

const FighterModal = ({ fighter, onClose, onSubscribe, isLoggedIn }) => {
  console.log(fighter);

  const renderTags = () => {
    const allTags = [];
    if (fighter.tags) {
      allTags.push(...fighter.tags.split(',').map((tag, index) => ({
        tag,
        key: `regular-${fighter.id}-${index}`
      })));
    }
    if (fighter.tagsDwcs) {
      allTags.push(...fighter.tagsDwcs.split(',').map((tag, index) => ({
        tag,
        key: `dwcs-${fighter.id}-${index}`
      })));
    }

    return allTags.map(({ tag, key }) => (
      <span key={key} className="card-text-tag">
        {tag.startsWith('dwcs') ? 'dwcs' : tag}
      </span>
    ));
  };

  const renderPersonalData = () => {
    const data = [];
    if (fighter.age) {
      data.push(`Age: ${fighter.age}`);
    }
    if (fighter.height && fighter.weight) {
      data.push(`Size: ${fighter.height}/${fighter.weight}`);
    }
    return data.join('\n');
  };

  const getDwcsInfo = () => {
    if (!fighter.tagsDwcs) return null;

    const dwcsTag = fighter.tagsDwcs.split(',').find(tag => tag.startsWith('dwcs.'));
    if (!dwcsTag) return null;

    // Extract season and episode from format like "dwcs.s6e1"
    const match = dwcsTag.match(/dwcs\.s(\d+)e(\d+)/);
    if (match) {
      const [, season, episode] = match;
      return `s${season}e${episode}`;
    }

    return null;
  };

  const renderNextFight = () => {
    const isValidDate = (date) => {
      return date && date !== '0000-00-00' && date !== '';
    };

    let fightDate = null;
    let opponentName = fighter.nextFightOpponent;
    let opponentRecord = fighter.nextFightOpponentRecord;
    let opponentUrl = fighter.opponentUfcUrl;

    // Case 1: If nextFightOpponent exists and matches rumour, but has no record
    if (fighter.nextFightOpponent && fighter.rumourNextFightOpponent &&
      (fighter.nextFightOpponent === fighter.rumourNextFightOpponent ||
        fighter.rumourNextFightOpponent.includes(fighter.nextFightOpponent)) &&
      !fighter.nextFightOpponentRecord) {
      opponentName = fighter.rumourNextFightOpponent;
      opponentRecord = fighter.rumourNextFightOpponentRecord;
      opponentUrl = fighter.rumourOpponentUfcUrl;
    }
    // Case 2: If no nextFightOpponent but rumour exists
    else if (!fighter.nextFightOpponent && fighter.rumourNextFightOpponent) {
      opponentName = fighter.rumourNextFightOpponent;
      opponentRecord = fighter.rumourNextFightOpponentRecord;
      opponentUrl = fighter.rumourOpponentUfcUrl;
    }

    if (isValidDate(fighter.nextFightDate)) {
      fightDate = fighter.nextFightDate;
      fighter.isNextFightOfficial = true;
    } else if (isValidDate(fighter.rumourNextFightDate)) {
      fightDate = fighter.rumourNextFightDate;
    }

    if (!fightDate) {
      return (
        <div>
          Next fight: <b>N/A</b>
        </div>
      );
    }

    return (
      <div>
        {fighter.isNextFightOfficial ? <i className="fa-regular fa-circle-check">[OFFICIAL] </i> : <i className="fa-regular fa-circle-check">[RUMOURED] </i>}
        Next fight: <br />
        <b>{fightDate.split('T')[0]}</b>
        <br />
        Opponent: <br />
        <a href={opponentUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
          <b>{opponentName}</b>
          {opponentRecord && (
            <>
              <br /><b>({opponentRecord})</b>
            </>
          )}
        </a>
      </div>
    );
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{fighter.name}</div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="modal-text">
            <div>{renderTags()}</div>
            <div>{renderPersonalData()}</div>
            <div>Division: <b>{fighter.weightClass}</b></div>
            <div>
              Record: <b>
                {fighter.record === "1-0-0" && fighter.sherdogRecord
                  ? fighter.sherdogRecord
                  : fighter.record}
              </b>
            </div>
            {getDwcsInfo() && (
              <div>
                DWCS: <b>{getDwcsInfo()}</b>
              </div>
            )}
            <div>{renderNextFight()}</div>
            <div>
              Links: <br />
              <a href={fighter.ufcUrl} className="modal-url" target="_blank" rel="noopener noreferrer">
                <img src="https://upload.wikimedia.org/wikipedia/commons/d/d7/UFC_Logo.png" width="30" alt="UFC" />
              </a>
              {fighter.sherdog && (
                <a href={fighter.sherdog} className="modal-url" target="_blank" rel="noopener noreferrer">
                  <img src="/sherdog.png" width="30" alt="Sherdog" />
                </a>
              )}
            </div>
            {isLoggedIn ? (
              <button
                className={`fighter-button fighter-sub-button ${fighter.subscription_status === '1' ? 'subbed' : ''}`}
                onClick={(e) => onSubscribe(fighter, e)}
              >
                {fighter.subscription_status === '1' ? (
                  <><i className="fas fa-envelope"></i>&nbsp;Subbed</>
                ) : (
                  <><i className="fa-solid fa-envelope-open"></i>&nbsp;Sub</>
                )}
              </button>
            ) : (
              <Link to="/auth" className="fighter-button fighter-sub-button">
                <i className="fa-solid fa-envelope-open"></i>&nbsp;Login to Subscribe
              </Link>
            )}
            {fighter.mydesc && (
              <div className="fighter-description">
                <h4>Notes:</h4>
                <p>{fighter.mydesc}</p>
              </div>
            )}
          </div>
          <div className="modal-image-container">
            <img
              src={fighter.fighterFullBodyImgUrl}
              alt={fighter.name}
              className="modal-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FighterModal; 